import React, {useState} from "react";
import {useEffectOnce} from "../../hooks/useEffectOnce";
import * as UserService from "../../api/UserService";

import GroupGameNotFoundStyle from "./GroupGameNotFound.module.css"
import commonStyle from "../Style.module.css";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";

export default function GroupGameNotFound(props) {
    const { t, i18n } = useTranslation('translation', { keyPrefix: 'gameNotFound' });
    const [loggedIn, setLoggedIn] = useState(undefined)
    const nav = useNavigate()

    useEffectOnce(()=> {
        UserService.verifyLogin(setLoggedIn)
    }, [])

    function onExit() {
        UserService.logout(
            () => {
                props.callGameState()
            }
        )
    }

    return <>
        <div className={GroupGameNotFoundStyle.gameNotFoundMain}>
            <h1>{t('gameNotFound')}</h1>
            {!loggedIn && <>
                <h3>{t('groupGameLoginAsMentor')}</h3>
                <button onClick={() => nav("/login")} className={`${commonStyle.defaultButtonColourAndText} ${commonStyle.buttonWithLink}`}>Увійти</button>
            </>}

            {loggedIn && <>
                <h3>{t('youActAsMentor')}</h3>
                <br/>
                <h3>{t('logoutToActAsPlayer')}</h3>
                <button onClick={onExit} className={`${commonStyle.defaultButtonColourAndText} ${commonStyle.buttonWithLink}`}>{t('logout')}</button>
            </>}
        </div>

    </>
}